export * from './patterns.module';
export * from './pipes/safeHtml.pipe';
